import { CircularProgress } from '@mui/material'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  useDeleteProjectUserMutation,
  useGetPriceListHistoryQuery,
  useUpdateProjectUserMutation,
} from 'apiv2'
import { groupRoleByUserId } from 'helpers/groupRoleByUserId'
import { useProjectPermissions } from 'hooks/useProjectPermissions'
import { closeUserRoleModal, userRoleModalSelector } from 'store/modals'
import {
  getProjectInfoAction,
  clearProjectInfo,
  getProjectUsersAction,
} from 'store/projects'
import ModalBasic from 'ui/components/ModalBasic/'
import { SelectNewUser } from './components/SelectNewUser'
import { SelectUser } from './components/SelectUser'
import {
  usePreviousSlug,
  useRoleList,
  useUserList,
  usePriceList,
} from './hooks'
import { LoadingContainer } from './styled'

const ModalUserRole = () => {
  const modalInfo = useSelector(userRoleModalSelector)
  const title = modalInfo?.title
  const open = modalInfo?.open
  const dispatch = useDispatch()
  const router = useRouter()
  const projectSlug = router.query.projectSlug || modalInfo?.projectSlug
  const handlerClose = () => {
    dispatch(closeUserRoleModal())
    dispatch(getProjectInfoAction(projectSlug))
    dispatch(getProjectUsersAction(projectSlug))

    // TODO переделать удаление сотрудников из проекта на rtq-query
    dispatch(getProjectInfoAction(projectSlug))
  }
  useEffect(() => {
    return () => dispatch(clearProjectInfo())
  }, [])
  const { projectInfo, isProjectInfoLoading, isSuccess, canEditProject } =
    useProjectPermissions(projectSlug)
  const [userList, updateUserList] = useUserList({
    open,
    users: projectInfo?.users,
  })

  const canEditProjectUsers = !projectInfo?.is_archived || canEditProject

  const roleList = useRoleList({ open })

  const { data: estimateHistory } = useGetPriceListHistoryQuery(projectSlug, {
    skip: !projectSlug,
  })

  const priceList = usePriceList({ open })

  const previousSlug = usePreviousSlug(isSuccess, projectSlug)

  const [updateProjectUserMutation] = useUpdateProjectUserMutation()
  const [deleteProjectUserMutation] = useDeleteProjectUserMutation()

  const isFullData = roleList && projectInfo && userList && priceList

  return (
    <ModalBasic
      size="large"
      open={open}
      handlerClose={handlerClose}
      title={title}
      onRouteChangeClose={handlerClose}
    >
      {!isFullData && isProjectInfoLoading && (
        <LoadingContainer>
          <CircularProgress />
        </LoadingContainer>
      )}
      {isFullData && !isProjectInfoLoading && previousSlug === projectSlug && (
        <>
          <SelectUser
            roleList={roleList}
            userList={userList}
            priceList={priceList}
            hasEstimate={!!estimateHistory?.current_details.length}
            updateProjectUserMutation={updateProjectUserMutation}
            deleteProjectUserMutation={deleteProjectUserMutation}
            users={groupRoleByUserId(projectInfo.users)}
            slug={projectSlug}
            canEditProjectUsers={canEditProjectUsers}
          />
          {canEditProjectUsers && (
            <SelectNewUser
              roleList={roleList}
              userList={userList}
              priceList={priceList}
              hasEstimate={!!estimateHistory?.current_details.length}
              updateProjectUserMutation={updateProjectUserMutation}
              updateUserList={updateUserList}
              slug={projectSlug}
            />
          )}
        </>
      )}
    </ModalBasic>
  )
}

const WrapperUserRole = () => {
  const modalInfo = useSelector(userRoleModalSelector)
  const open = modalInfo?.open
  const slug = modalInfo?.projectSlug

  useEffect(() => {
    if (slug) {
      sessionStorage.setItem('slug', slug)
    }
  }, [slug])

  if (!open) {
    return null
  }

  return <ModalUserRole />
}

export default WrapperUserRole
